module.exports = __webpack_public_path__ + "img/specialist-schedule.2d11f6b9.svg";